module.exports = __webpack_public_path__ + "static/logo.860b0765.png";


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/resources/images/tower/logo.png
// module id = 251
// module chunks = 0